import { AffiliationType, EmployeeRole } from '@/api/apis/resources';
import { CUSTOMER_PERMISSION_NAMES, CUSTOMER_ROLE_NAMES, OPO_ROLE_NAMES } from './customer.constants';
import { CaseUserGroup } from '@/api/apis/case';

export const clinicalManagementGroups = [
  CaseUserGroup.ClinicalCoordinators,
  CaseUserGroup.OrganManagementSpecialists,
  CaseUserGroup.ClinicalLeads,
];

export const logisticsManagementGroups = [
  CaseUserGroup.SrLogisticsManagers,
  CaseUserGroup.LogisticsManagers,
  CaseUserGroup.AviationSpecialists,
  CaseUserGroup.GroundSpecialists,
];

export const caseManagementGroups = [...clinicalManagementGroups, ...logisticsManagementGroups];

export const primaryAvailableGroups = [
  CaseUserGroup.ClinicalCoordinators,
  CaseUserGroup.OrganManagementSpecialists,
  CaseUserGroup.ClinicalLeads,
  CaseUserGroup.LogisticsManagers,
  CaseUserGroup.AviationSpecialists,
  CaseUserGroup.GroundSpecialists,
];

export const groupsWithMandatoryPrimary = [
  CaseUserGroup.ClinicalCoordinators,
  CaseUserGroup.OrganManagementSpecialists,
];

export const EMPLOYEE_ROLE_NAMES = {
  [EmployeeRole.Admin]: 'Admin',
  [EmployeeRole.SuperAdmin]: 'Super Admin',
  [EmployeeRole.TechSupportAdmin]: 'Tech Support Admin',
  [EmployeeRole.AviationSpecialist]: 'Aviation Specialist',
  [EmployeeRole.ClinicalCoordinator]: 'Clinical Coordinator',
  [EmployeeRole.ClinicalLead]: 'Clinical Lead',
  [EmployeeRole.ClinicalSpecialist]: 'Clinical Specialist',
  [EmployeeRole.CLevel]: 'C-level',
  [EmployeeRole.FinanceAuditor]: 'Finance Auditor',
  [EmployeeRole.GroundSpecialist]: 'Ground Specialist',
  [EmployeeRole.LogisticsManager]: 'Logistics Manager',
  [EmployeeRole.MaintenanceOfficer]: 'Maintenance Officer',
  [EmployeeRole.OrganLeadership]: 'Organ Leadership',
  [EmployeeRole.OrganManagement]: 'Organ Management',
  [EmployeeRole.OrganManagementSpecialist]: 'Organ Management Specialist',
  [EmployeeRole.QuoteApprovers]: 'Quote Approver',
  [EmployeeRole.RegularUser]: 'Regular User',
  [EmployeeRole.CommercialAdoption]: 'Commercial Adoption',
  [EmployeeRole.CommercialAdoptionManagement]: 'Commercial Adoption Management',
  [EmployeeRole.RetrievalSurgeon]: 'Retrieval Surgeon',
  [EmployeeRole.ScheduleManagerCc]: 'Schedule Manager CC',
  [EmployeeRole.ScheduleManagerCs]: 'Schedule Manager CS',
  [EmployeeRole.ScheduleManagerRs]: 'Schedule Manager RS',
  [EmployeeRole.ScheduleManagerOms]: 'Schedule Manager OMS',
  [EmployeeRole.SrLogisticsManager]: 'Senior Logistics Manager',
  [EmployeeRole.LogisticsTeamManagement]: 'Logistics Team Management',
  [EmployeeRole.ContractorRetrievalSurgeon]: 'Contractor Retrieval Surgeon',
  [EmployeeRole.ClinicalAuditor]: 'Clinical Auditor',
  [EmployeeRole.ClinicalAffairsLeadership]: 'Clinical Affairs Leadership',
  [EmployeeRole.Section16Officer]: 'Section 16 Officer',
  [EmployeeRole.NationalCSManagement]: 'National CS Management',
  [EmployeeRole.RegionalCSManagement]: 'Regional CS Management',
  [EmployeeRole.ClinicalCoordinatorManagement]: 'Clinical Coordinator Management',
} as const;

export const CONTRACTOR_AFFILIATION_NAMES = {
  [AffiliationType.NoContract]: 'No Contract',
  [AffiliationType.OPO]: 'OPO',
  [AffiliationType.TMDXContract]: 'TMDX Contract',
  [AffiliationType.TXCenter]: 'TX Center',
} as const;

export const roleNames = {
  ...EMPLOYEE_ROLE_NAMES,
  ...CUSTOMER_ROLE_NAMES,
  ...CUSTOMER_PERMISSION_NAMES,
  ...OPO_ROLE_NAMES,
};

export const SYSTEM_USER_ID = '00000000-0000-0000-0000-ffffffffffff';
